module.exports = __webpack_public_path__ + "media/images/flags/64/Serbia-cc1e59bdc6a3c21e715fd5c387606a51.png";